import { useState } from "react";
import { BASE_URL } from "../../utils/axiosConfig";

const URL = "/download";
const H2_ATLAS = "H2-Atlas";

export const useDownloadDataset = () => {
  const [progress, setProgress] = useState(null);
  const [isComplete, setIsComplete] = useState(false);
  const [error, setError] = useState(null);

  const downloadDataset = async (sourceId) => {
    try {
      const response = await fetch(
        `${BASE_URL}${URL}/geojson?sourceId=${sourceId}`
      );

      // Create a writable stream for the file
      const fileHandle = await window.showSaveFilePicker({
        suggestedName: `${H2_ATLAS}-${sourceId}.geojson`,
        types: [
          {
            description: "JSON Files",
            accept: { "application/json": [".json"] },
          },
        ],
      });

      let downloadedSize = 0;

      const writable = await fileHandle.createWritable();
      const reader = response.body.getReader();

      const pump = async () => {
        let buffer = []; // Temporary buffer for chunks
        let bufferSize = 0; // Track the buffer size
        const threshold = 64 * 1024; // 64 KB threshold

        // eslint-disable-next-line no-constant-condition
        while (true) {
          const { done, value } = await reader.read();
          // Calculate and log progress
          const calculatedProgress = `${parseFloat(
            (downloadedSize / Math.pow(1024, 2)).toFixed(2)
          )} MB`;
          if (done) {
            if (buffer.length > 0) {
              await writable.write(new Blob(buffer)); // Write remaining chunks
            }
            setProgress(calculatedProgress);
            setIsComplete(true);
            setProgress("Download complete!");
            setProgress(null);
            break;
          }

          buffer.push(value);
          bufferSize += value.byteLength;
          downloadedSize += value.byteLength;

          setProgress(calculatedProgress);

          // Write to the stream when the buffer reaches a threshold (e.g., 64 KB)
          if (bufferSize >= threshold) {
            await writable.write(new Blob(buffer)); // Write the batched chunks
            buffer = [];
            bufferSize = 0;
          }
        }

        await writable.close();
      };
      return await pump();
    } catch (error) {
      setError(error.message);
      console.error(error);
    }
  };

  return {
    downloadDataset,
    progress,
    isComplete,
    error,
  };
};
